import React from 'react'
import PopupMenuButton from "../../../../../core/gd-components/popover-menu/popup-menu-button/popup-menu-button";
import QuickSearch_SettingsPopover from "./popover";
import UI5ControlButton from "../../../../../layout/app-controls/buttons/button/button";
import QuickSearch from "../../model/quick-search";

type Props = {
    className?          : string

    quickSearch     : QuickSearch
}


export default function QuickSearch_Settings(props: Props) {

    return (
        <PopupMenuButton
            menuComponent={()=>{
                return <QuickSearch_SettingsPopover onSettingsChanged={props.quickSearch.onSettingsChanged} />
            }}
            btnComponent={()=>{
                return <UI5ControlButton label="Settings" iconClass="i5-settings" />
            }}
            menuParams={{

            }}
        />
    )

}
